export default __webpack_public_path__ + "static/media/016-monkey.ddb97087.svg";